@if (isWidgetActive() && !isWidgetHidden) {
    <div
        id="exportSurveyData"
        class="widget container-fluid well"
        cdkDrag
        [cdkDragConstrainPosition]="computeDragPosition"
        #widget>
        <div
            class="col-xs-12 widget-header"
            cdkDragHandle>
            <span>{{widgetConfig.header}}</span>
            <div class="pull-right btn-group btn-group-xs">
                <nlrp-help-link
                    [url]="helpLinkUrl"
                    [pageTitle]="helpPageTitle"></nlrp-help-link>
                <i
                    class="nlrp-icon nlrp-18"
                    [ngClass]="open ? 'nlrp-icon-up-chevron' : 'nlrp-icon-down-chevron'"
                    [title]="open ? widgetConfig.collapseTooltip : widgetConfig.expandTooltip"
                    (click)="toggleWidgetContentVisibility()">
                </i>
                <i
                    class="nlrp-icon nlrp-icon-close-cancel nlrp-18"
                    [title]="widgetConfig.closeTooltip"
                    id="exportSurveyCloseBtn"
                    (click)="toggleWidgetVisibility()"></i>
            </div>
        </div>
        @if (open) {
            <div class="widget-content">
                <div class="col-xs-12 mgt10">
                    <label
                        class="col-xs-4 p0 control-label"
                        for="fileType"
                        >File Type</label
                    >
                    <div class="col-xs-8 p0">
                        <div class="input-group">
                            <ng-select
                                class="nlr-ng-select"
                                [searchable]="false"
                                [clearable]="false"
                                name="fileType"
                                id="fileType"
                                placeholder="Select"
                                [items]="fileTypes"
                                bindLabel="FILE_TYPE"
                                [(ngModel)]="selectedFileType"
                                (change)="updateSelectedFileType($event)"
                                required>
                            </ng-select>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 mgt10 mgb10  inline-bottom-buttons">
                    <button
                        class="btn btn-default nlr-btn-sm"
                        id="exportBtn"
                        (click)="submit()"
                        >Export</button
                    >
                    <button
                        class="btn btn-default nlr-btn-sm"
                        id="closeBtn"
                        (click)="toggleWidgetVisibility()"
                        [disabled]="processing"
                        >Close</button
                    >
                </div>
                @if (processing) {
                    <div class="row mgt10">
                        <label class="col-xs-12 control-label">{{lastMessage}}</label>
                    </div>
                }
            </div>
        }
    </div>
}
